import { z } from "zod/v4";

/** Finished creatives shown in the campaign's current ads card. */
export const CURRENT_LEAD_AD_STATUSES = ["ACTIVE", "PAUSED"] as const;

const rebuildSchema = z.object({
  status: z.enum(["RUNNING", "COMPLETE", "FAILED"]),
  requestId: z.string().optional(),
  runId: z.string().optional(),
  done: z.number().default(0),
  total: z.number().default(0),
  processed: z.number().optional(),
  failedCreativeIds: z.array(z.string()).optional(),
  errors: z.record(z.string(), z.string()).optional(),
  error: z.string().optional(),
  updatedAt: z.string().optional(),
  finishedAt: z.string().optional(),
});

export type LeadAdBrandRebuild = z.infer<typeof rebuildSchema>;

/** A killed worker cannot run finally; both UI surfaces must show that failure. */
export function resolveLeadAdBrandRebuild(
  value: unknown,
  now = Date.now(),
): LeadAdBrandRebuild | null {
  const result = rebuildSchema.safeParse(value);
  if (!result.success) return null;
  const rebuild = result.data;
  const updatedAt = Date.parse(rebuild.updatedAt ?? "");
  if (
    rebuild.status === "RUNNING" &&
    (!Number.isFinite(updatedAt) || now - updatedAt > 15 * 60 * 1000)
  ) {
    return {
      ...rebuild,
      status: "FAILED",
      error:
        "The ad update stopped before it finished. Apply your saved brand again to retry.",
    };
  }
  return rebuild;
}
